import { create } from 'zustand';

const messages = {
  cancel: 'キャンセル',
  close: '閉じる',
};

type ConfirmDialogData = {
  title: string;
  content?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmDialog?: () => void;
  isPositive?: boolean;
  disableConfirmButton?: boolean;
  crossClose?: boolean;
  closeDialog?: () => void;
};

export interface ConfirmDialogStore {
  open: boolean;
  title: string;
  content: string;
  confirmButtonText: string;
  cancelButtonText: string;
  isPositive: boolean;
  disableConfirmButton: boolean;
  crossClose: boolean;
  handleConfirmDialog: () => void;
  handleClose: () => void;
  setConfirmDialog: (data: ConfirmDialogData) => void;
}

export const useConfirmDialog = create<ConfirmDialogStore>((set) => ({
  open: false,
  title: '',
  content: '',
  confirmButtonText: messages.close,
  cancelButtonText: messages.cancel,
  isPositive: true,
  disableConfirmButton: false,
  crossClose: false,
  handleConfirmDialog: () => set({ open: false }),
  handleClose: () => set({ open: false }),
  setIsPositive: (isPositive: boolean) => set({ isPositive }),
  setDisableConfirmButton: (disableConfirmButton: boolean) => set({ disableConfirmButton }),
  setCrossClose: (crossClose: boolean) => set({ crossClose }),
  setConfirmDialog: (data: ConfirmDialogData) => {
    if (!data.title) return; // title is required
    set({
      open: true,
      title: data.title,
      content: data.content ?? '',
      confirmButtonText: data.confirmButtonText ?? messages.close,
      cancelButtonText: data.cancelButtonText,
      handleConfirmDialog: () => {
        data.confirmDialog?.();
        set({ open: false });
      },
      isPositive: data.isPositive ?? true,
      disableConfirmButton: data.disableConfirmButton ?? false,
      crossClose: data.crossClose ?? false,
      handleClose: () => {
        data.closeDialog?.();
        set({ open: false });
      },
    });
  },
}));
